// extracted by mini-css-extract-plugin
export default {"consultation":"ConsultationSection_consultation__HdfOp","textWrapper":"ConsultationSection_textWrapper__1j-7c"};